import type { AnyDomainEntity } from 'metalworks-domain'
import { Hole, KickPlateFixingHoles } from 'metalworks-domain'

import type { UpdateTransformer } from '@salsita-ai/platform-project-sdk/domain'

/*
 * Transformer, which copies some necessary attributes from the original feature
 * to the new feature when the feature is replaced.
 */
export const copyFeatureAttributesOnReplaceTransformer =
  (): UpdateTransformer<AnyDomainEntity> => (updates, previousState) => {
    return updates.map(update => {
      if (update.kind !== 'replaceDomainEntity') {
        return update
      }

      const originalEntity = previousState.entities.find(e => e.id === update.entityId)
      if (!originalEntity) {
        throw new Error('Original entity not found!')
      }

      const newEntity = update.replacementEntity
      if (!Hole.is(originalEntity) || !Hole.is(newEntity)) {
        return update
      }

      // TODO: this can can be done as part of the replace entity expressions
      return {
        ...update,
        replacementEntity: {
          ...newEntity,
          x: originalEntity.x,
          y: originalEntity.y,
          anchorPointFromId: originalEntity.anchorPointFromId,
          anchorPointToId: originalEntity.anchorPointToId,
          ...(KickPlateFixingHoles.is(originalEntity) && KickPlateFixingHoles.is(newEntity)
            ? { horizontalCount: originalEntity.horizontalCount, verticalCount: originalEntity.verticalCount }
            : {}),
        },
      }
    })
  }
